import React, { useState, useEffect } from 'react';
import noConnectionImg from './broken_internet.jpg';
import { MdNetworkCheck } from 'react-icons/md';

const NoInternetConnection = (props: any) => {
   const [isOnline, setOnline] = useState(true);
   useEffect(() => {
      setOnline(navigator.onLine)
   }, [])

   window.addEventListener('online', () => {
      setOnline(true)
   });

   window.addEventListener('offline', () => {
      setOnline(false)
   });

   if (isOnline) {
      return props.children
   } else {
      return (
         <div className="content_sec white wf-section" style={{ height: '100vh' }}>
            <div className="signup_top_info">
               <div className="signup_pict failure">
                  <img src="/assets/images/broken_internet.svg" />
               </div>
               <h2 className="signup_title welcome">נראה שיש בעיה בחיבור לאינטרנט</h2>
               <div>כדי להמשיך, כדאי לבדוק שהחיבור לאינטרנט תקין ושהטלפון הנייד לא במצב טיסה</div>
               <a href="#" className="button_full welcome w-button">בוא ננסה שוב</a>
            </div>
         </div>
      )
   }
}

export default NoInternetConnection;